import { render, staticRenderFns } from "./AdmissionsPortal.vue?vue&type=template&id=2b1fc37a&scoped=true"
import script from "./AdmissionsPortal.vue?vue&type=script&lang=js"
export * from "./AdmissionsPortal.vue?vue&type=script&lang=js"
import style0 from "./AdmissionsPortal.vue?vue&type=style&index=0&id=2b1fc37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fc37a",
  null
  
)

export default component.exports